var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oversea-billing" },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticClass: "section",
          staticStyle: { height: "100%" },
          attrs: {
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: "5px"
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px"
            }
          }
        },
        [
          _c(
            "template",
            { slot: "up" },
            [
              _c("div", { staticClass: " operations" }, [
                _c(
                  "div",
                  { staticClass: "triggers" },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.controllerVisible.showSpecialCharge,
                                expression:
                                  "controllerVisible.showSpecialCharge"
                              }
                            ],
                            staticStyle: {
                              color: "#404144",
                              "margin-right": "5px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("FinanceManage.domestic_billingBranchId")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-select",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.controllerVisible.showSpecialCharge,
                                expression:
                                  "controllerVisible.showSpecialCharge"
                              }
                            ],
                            staticStyle: { "margin-right": "5px" },
                            attrs: {
                              disabled: !_vm.readonly,
                              splaceholder: _vm.$t("Message.PleaseSelect"),
                              clearable: false,
                              size: "mini"
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.onBillingBranchIdHandler(p)
                              }
                            },
                            model: {
                              value: _vm.specialBillingBranchId,
                              callback: function($$v) {
                                _vm.specialBillingBranchId = $$v
                              },
                              expression: "specialBillingBranchId"
                            }
                          },
                          _vm._l(_vm.officeList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.chineseName,
                                value: item.officeId
                              }
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-checkbox",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.masterFlag,
                                expression: "masterFlag"
                              }
                            ],
                            staticStyle: { "margin-right": "5px" },
                            attrs: { no: "showAllBilling" },
                            on: {
                              change: function($event) {
                                return _vm.pm.showAllBillingChangeHandler()
                              }
                            },
                            model: {
                              value: _vm.cbShowAllBilling,
                              callback: function($$v) {
                                _vm.cbShowAllBilling = $$v
                              },
                              expression: "cbShowAllBilling"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "FinanceManage.international_showAllBilling"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.controllerVisible.cbShowSelfChanges,
                                expression:
                                  "controllerVisible.cbShowSelfChanges"
                              }
                            ],
                            staticStyle: { "margin-right": "5px" },
                            attrs: { no: "commissionedChargesOnly" },
                            on: {
                              change: function($event) {
                                return _vm.pm.showSelfChargeChangeHandler()
                              }
                            },
                            model: {
                              value: _vm.cbShowSelfChanges,
                              callback: function($$v) {
                                _vm.cbShowSelfChanges = $$v
                              },
                              expression: "cbShowSelfChanges"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "FinanceManage.international_commissionedChargesOnly"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.controllerVisible.cbShowInternal,
                                expression: "controllerVisible.cbShowInternal"
                              }
                            ],
                            staticStyle: { "margin-right": "5px" },
                            attrs: { no: "domestic_showInternal" },
                            on: {
                              change: function($event) {
                                return _vm.pm.showInternalChargeHandler()
                              }
                            },
                            model: {
                              value: _vm.cbShowInternal,
                              callback: function($$v) {
                                _vm.cbShowInternal = $$v
                              },
                              expression: "cbShowInternal"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                this.$t("CargoMsg.Cargo_ShowInternalCharges")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "cargo-button-group-slider",
                      {
                        staticStyle: { flex: "1", border: "none" },
                        attrs: { align: "right" }
                      },
                      [
                        _c(
                          "div",
                          [
                            _vm._l(_vm.instructioinBtns, function(item, index) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    key: index,
                                    attrs: {
                                      no: item.platformInstructionRuleCode,
                                      type: "primary",
                                      disabled:
                                        item.platformInstructionRuleCode ===
                                        "overseaBillEdit"
                                          ? !item.allowOperate ||
                                            !_vm.btnEnable.btnEdit
                                          : !item.allowOperate
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onInstructionClick(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$selectByLang(
                                            item.chineseName,
                                            item.englishName,
                                            item.japaneseName
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            }),
                            !_vm.billPageSet.newHide
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "international_add",
                                      type: "primary",
                                      disabled: !_vm.btnEnable.btnAdd
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onAddClickEvent()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "FinanceManage.international_add"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            !_vm.billPageSet.editHide
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "btnEdit",
                                      type: "primary",
                                      disabled: !_vm.btnEnable.btnEdit
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onEditClickEvent()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "FinanceManage.international_edit"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.permission.btnDel,
                                    expression: "permission.btnDel"
                                  }
                                ],
                                attrs: {
                                  no: "btnDel",
                                  type: "danger",
                                  disabled:
                                    _vm.selectedDataList.length > 0
                                      ? false
                                      : !_vm.btnEnable.btnDel
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onDelClickEvent()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("FinanceManage.international_delete")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled:
                                    _vm.isEdit ||
                                    !_vm.selectedBilling ||
                                    _vm.selectedBilling.billingType ===
                                      "代理分成账单"
                                },
                                on: { click: _vm.viewClickHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(this.$t("FinanceManage.domestic_view"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.permission.btnAutid &&
                                      _vm.viewSource !== "salesDetail",
                                    expression:
                                      "permission.btnAutid && viewSource!=='salesDetail'"
                                  }
                                ],
                                attrs: {
                                  no: "btnAutid",
                                  type: "primary",
                                  disabled: !_vm.btnEnable.btnAutid
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onAutidClickEvent()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("FinanceManage.international_audit")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.permission.btnInvalid,
                                    expression: "permission.btnInvalid"
                                  }
                                ],
                                attrs: {
                                  no: "btnInvalid",
                                  type: "primary",
                                  disabled: !_vm.btnEnable.btnInvalid
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onInvaidClickEvent()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.international_invalid"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.viewSource !== "salesDetail",
                                    expression: "viewSource!=='salesDetail'"
                                  }
                                ],
                                attrs: {
                                  no: "btnAgent",
                                  disabled: !_vm.btnEnable.btnAgent,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onAgentClickEvent()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.international_agentProfitShareBillNo"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.controllerVisible.btnPrintAllAgent,
                                    expression:
                                      "controllerVisible.btnPrintAllAgent"
                                  }
                                ],
                                attrs: {
                                  no: "btnPrintAllAgent",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onPrintAllAgentClickEvent()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.international_printAllAgentProfitShareBillNo"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.permission.btnEditAgentBillNo,
                                    expression: "permission.btnEditAgentBillNo"
                                  }
                                ],
                                attrs: {
                                  no: "btnEditAgentBillNo",
                                  type: "primary",
                                  disabled: !_vm.btnEnable.btnEditAgentBillNo
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onEditAgentBillNoClickEvent()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.international_editAgentBillNo"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$checkPermission([
                                      "button_Billing_overseaBillingConfrim"
                                    ]),
                                    expression:
                                      "$checkPermission(['button_Billing_overseaBillingConfrim'])"
                                  }
                                ],
                                attrs: {
                                  no: "overseaBillingConfrim",
                                  type: "primary",
                                  disabled:
                                    _vm.selectedDataList.length > 0
                                      ? false
                                      : !_vm.btnEnable.btnConfirm
                                },
                                on: { click: _vm.btnConfrimClickHandle }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("FinanceManage.domestic_confirm")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$checkPermission([
                                      "button_Billing_overseaBillingCancelConfrim"
                                    ]),
                                    expression:
                                      "$checkPermission(['button_Billing_overseaBillingCancelConfrim'])"
                                  }
                                ],
                                attrs: {
                                  no: "overseaBillingCancelConfrim",
                                  type: "primary",
                                  disabled:
                                    _vm.selectedDataList.length > 0
                                      ? false
                                      : !_vm.btnEnable.btnCancelConfirm
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.btnCancelConfrimHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.domestic_cancelConfirm"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  type: "primary",
                                  content: _vm.$t("Billing.billing_recheckTip"),
                                  placement: "bottom"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: [
                                          "button_billTab_overseaBillingRecheck"
                                        ],
                                        expression:
                                          "['button_billTab_overseaBillingRecheck']"
                                      }
                                    ],
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "recheck",
                                      type: "primary",
                                      disabled: !_vm.btnEnable.btnRecheck
                                    },
                                    on: { click: _vm.btnRecheckClickHandle }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(this.$t("Billing.billing_recheck"))
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: [
                                      "button_billTab_overseaBillingCancelRecheck"
                                    ],
                                    expression:
                                      "['button_billTab_overseaBillingCancelRecheck']"
                                  }
                                ],
                                attrs: {
                                  no: "cancelRecheck",
                                  type: "primary",
                                  disabled: !_vm.btnEnable.btnCancelRecheck
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.btnCancelRecheckBillingHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    this.$t("Billing.billing_cancelRecheck")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$checkPermission([
                                      "button_billTab_forceDelete"
                                    ]),
                                    expression:
                                      "$checkPermission(['button_billTab_forceDelete'])"
                                  }
                                ],
                                attrs: {
                                  no: "forceDelete",
                                  type: "danger",
                                  disabled:
                                    _vm.selectedDataList.length > 0
                                      ? false
                                      : _vm.isEdit && !_vm.pm.isOcPaymentLock
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.forceDeleteHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_ForceDelete"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.$checkPermission([
                                      "button_billTab_payauthFromBilling"
                                    ]),
                                    expression:
                                      "$checkPermission(['button_billTab_payauthFromBilling'])"
                                  }
                                ],
                                attrs: {
                                  no: "payauthFromBillin",
                                  type: "primary",
                                  disabled:
                                    _vm.isEdit ||
                                    _vm.up.selectedRows.length === 0
                                },
                                on: { click: _vm.applyForPayment }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Billing.billing_applyForPayment")
                                  )
                                )
                              ]
                            )
                          ],
                          2
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c("cargo-ag-grid", {
                staticStyle: { "flex-grow": "1", "margin-top": "10px" },
                attrs: {
                  no: "130126",
                  "config-module": "130126",
                  "grid-options": _vm.up.gridOptions,
                  "grid-params": _vm.up.gridParams,
                  "column-defs": _vm.upColumnDefs,
                  "row-data": _vm.billingList
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.up, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.up, "gridParams", $event)
                  },
                  gridReady: function(params) {
                    return (_vm.up.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "template",
            { slot: "down" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { flex: "1", margin: "10px 0px" },
                attrs: {
                  no: "130127",
                  "config-module": "130127",
                  "grid-options": _vm.down.gridOptions,
                  "grid-params": _vm.down.gridParams,
                  "column-defs": _vm.downColumnDefs,
                  "row-data": _vm.chargeList
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.down, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.down, "gridParams", $event)
                  },
                  gridReady: function(params) {
                    return (_vm.down.gridApi = params.api)
                  }
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm.overseaBillingDialog.visible
        ? _c("oversea-billing-dialog", {
            ref: "overseaBillingDialog",
            attrs: {
              visible: _vm.overseaBillingDialog.visible,
              job: _vm.overseaBillingDialog.job,
              "prop-billing": _vm.overseaBillingDialog.propBilling,
              "is-add-or-edit": _vm.overseaBillingDialog.isAddOrEdit,
              "debit-chargetax-rate":
                _vm.overseaBillingDialog.debitChargetaxRate,
              "prop-billing-charge-accounts":
                _vm.overseaBillingDialog.billingChargeAccounts,
              "billing-charge-detail":
                _vm.overseaBillingDialog.billingChargeDetail,
              "current-billing-branch-id":
                _vm.overseaBillingDialog.currentBillingBranchId,
              "department-team-user":
                _vm.overseaBillingDialog.departmentTeamUser,
              "create-bill-way": _vm.overseaBillingDialog.createBillWay,
              "create-oversea-charge": _vm.createOverseaCharge,
              location: _vm.location,
              "show-wht-tax": _vm.showWhtTax,
              "instruction-btns": _vm.overseaBillingDialog.instructionBtns
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.overseaBillingDialog, "visible", $event)
              },
              applyInvoice: function(bill) {
                _vm.toMakeInvoice(bill, function() {
                  _vm.overseaBillingDialog.visible = false
                })
              },
              onCloseCallBackFun: _vm.onCloseCallBackFun
            }
          })
        : _vm._e(),
      _vm.newOverseaBillingDialog.visible
        ? _c("split-oversea-billing-dialog", {
            ref: "overseaBillingDialog",
            attrs: {
              visible: _vm.newOverseaBillingDialog.visible,
              job: _vm.overseaBillingDialog.job,
              "prop-billing": _vm.overseaBillingDialog.propBilling,
              "is-add-or-edit": _vm.overseaBillingDialog.isAddOrEdit,
              "debit-chargetax-rate":
                _vm.overseaBillingDialog.debitChargetaxRate,
              "prop-billing-charge-accounts":
                _vm.overseaBillingDialog.billingChargeAccounts,
              "billing-charge-detail":
                _vm.overseaBillingDialog.billingChargeDetail,
              "current-billing-branch-id":
                _vm.overseaBillingDialog.currentBillingBranchId,
              "department-team-user":
                _vm.overseaBillingDialog.departmentTeamUser,
              "customer-detail": _vm.newOverseaBillingDialog.customerDetail,
              "create-bill-way": _vm.overseaBillingDialog.createBillWay,
              "create-oversea-charge": _vm.createOverseaCharge,
              location: _vm.location,
              "show-wht-tax": _vm.showWhtTax,
              "instruction-btns": _vm.overseaBillingDialog.instructionBtns
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.newOverseaBillingDialog, "visible", $event)
              },
              applyInvoice: function(bill) {
                _vm.toMakeInvoice(bill, function() {
                  _vm.newOverseaBillingDialog.visible = false
                })
              },
              viewInvoice: function(invoiceUuids) {
                _vm.newOverseaBillingDialog.visible = false
                _vm.$refs.invoice.openInvoiceDetails(invoiceUuids)
              },
              onCloseCallBackFun: _vm.onCloseCallBackFun
            }
          })
        : _vm._e(),
      _vm.editAgentBillNoDialog.visible
        ? _c("edit-agent-bill-no-dialog", {
            attrs: {
              visible: _vm.editAgentBillNoDialog.visible,
              billing: _vm.selectedBilling
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.editAgentBillNoDialog, "visible", $event)
              },
              editAgentBillNoSaveSuccessHandler:
                _vm.editAgentBillNoSaveSuccessHandler
            }
          })
        : _vm._e(),
      _vm.agencyShareBillDialog.visible
        ? _c("agency-share-bill-dialog", {
            attrs: {
              visible: _vm.agencyShareBillDialog.visible,
              "prop-billing": _vm.agencyShareBillDialog.propBilling,
              job: _vm.agencyShareBillDialog.job,
              "current-billing-branch-id":
                _vm.agencyShareBillDialog.currentBillingBranchId,
              "view-source": _vm.viewSource,
              location: _vm.location
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.agencyShareBillDialog, "visible", $event)
              },
              agentSaveSuccessHandler: _vm.agentSaveSuccessHandler
            }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        ref: "templateDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("bill-payment-dialog", {
        ref: "billPayment",
        attrs: {
          "open-sap-config": false,
          visible: _vm.showBillPaymentDialog,
          "create-submit": true,
          step: "step2",
          source: "append",
          "bill-payment-uuid": _vm.billPaymentDialogUuid,
          job: _vm.job,
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            _vm.showBillPaymentDialog = $event
          },
          cancel: _vm.cancel,
          toPreStepForBusiness: function(p) {
            this$1.showBillPaymentDialog = false
            _vm.toPreStep()
          }
        }
      }),
      _c("new-bill-payment-dialog", {
        attrs: {
          visible: _vm.billPaymentDialogForH5.visible,
          title: _vm.billPaymentDialogForH5.title,
          "bill-payment-account-id":
            _vm.billPaymentDialogForH5.defaultConditions.accountId,
          "view-source": _vm.billPaymentDialogForH5.source,
          "bill-payment-uuid": _vm.billPaymentDialogForH5.uuid,
          "default-conditions": _vm.billPaymentDialogForH5.defaultConditions
        },
        on: {
          close: function($event) {
            _vm.billPaymentDialogForH5.visible = false
          }
        }
      }),
      _vm.billPaymentDialogForH5.billPaymentDetailProperties.visible
        ? _c("bill-payment-detail-for-h5", {
            ref: "billPaymentDetailForH5",
            attrs: {
              "bill-payment-uuid":
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.uuid,
              title:
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.title,
              visible:
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.visible,
              state:
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.state,
              charges:
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.charges,
              "charges-dirty": true,
              "bill-payment-dirty": true,
              "open-sap-config": false,
              "input-by":
                _vm.billPaymentDialogForH5.billPaymentDetailProperties.inputBy,
              "parent-context": this,
              location: _vm.location,
              "view-source": "tabBilling"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.billPaymentDialogForH5.billPaymentDetailProperties,
                  "visible",
                  $event
                )
              },
              toPreStep: _vm.toPreStep,
              refreshBillPayment: _vm.refreshBillPaymentH5
            }
          })
        : _vm._e(),
      _vm.overseaBillDetail.visible
        ? _c("oversea-bill-detail", {
            attrs: {
              visible: _vm.overseaBillDetail.visible,
              "billing-uuid": _vm.overseaBillDetail.billingUuid,
              "create-oversea-charge": _vm.createOverseaCharge,
              "show-wht-tax": _vm.showWhtTax
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.overseaBillDetail, "visible", $event)
              },
              applyInvoice: function(bill) {
                _vm.toMakeInvoice(bill, function() {
                  _vm.overseaBillDetail.visible = false
                })
              },
              viewInvoice: function(invoiceUuids) {
                _vm.overseaBillDetail.visible = false
                _vm.$refs.invoice.openInvoiceDetails(invoiceUuids)
              }
            }
          })
        : _vm._e(),
      _c("make-invoice-dialog", {
        ref: "invoice",
        attrs: { "view-source": "overseaBilling", location: _vm.location },
        on: { reloadData: _vm.onCloseCallBackFun }
      }),
      _c("settlement-select-dialog", {
        attrs: {
          visible: _vm.settlementSelectDialog.visible,
          title: _vm.settlementSelectDialog.title,
          accounts: _vm.settlementSelectDialog.accounts,
          settlements: _vm.settlementSelectDialog.settlements,
          source: "overseaBilling"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.settlementSelectDialog, "visible", $event)
          },
          selectItemWinHandler: _vm.selectItemWinHandler
        }
      }),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.job.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }